import { render, staticRenderFns } from "./userArea.vue?vue&type=template&id=fb524ad8&scoped=true&"
import script from "./userArea.vue?vue&type=script&lang=js&"
export * from "./userArea.vue?vue&type=script&lang=js&"
import style0 from "./userArea.vue?vue&type=style&index=0&id=fb524ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb524ad8",
  null
  
)

export default component.exports